import { guid } from '@/mixins/guid';

function icnShape(mrg = {}) {
  return () =>
    Object.assign(
      {
        _id: guid.methods.guid(),
        type: 'droplet.socialMedia.socialMediaItem',
        size: '24pt',
        colorScheme: 'default',
        active: false,
        cls: `icon${mrg.name}`,
      },
      mrg,
    );
}

export default function socialMedia() {
  return {
    _id: false,
    type: 'droplet.socialMedia',
    socialIcons: [
      { name: 'Facebook', link: 'https://www.facebook.com/', active: true },
      { name: 'Twitter', link: 'https://www.twitter.com/', active: true },
      { name: 'Instagram', link: 'https://www.instagram.com/' },
      { name: 'Linkedin', link: 'https://www.linkedin.com/' },
      { name: 'Pinterest', link: 'https://www.pinterest.com/' },
      { name: 'Slack', link: 'https://www.slack.com/' },
      { name: 'YouTube', link: 'https://www.youtube.com/' },
      { name: 'Spotify', link: 'https://www.spotify.com/' },
      { name: 'Tumblr', link: 'https://www.tumblr.com/' },
      { name: 'Reddit', link: 'https://www.reddit.com/' },
      { name: 'Podcast', link: 'https://podcasts.apple.com/' },
      { name: 'Dribbble', link: 'https://www.dribbble.com/' },
      { name: 'Vimeo', link: 'https://www.vimeo.com/' },
      { name: 'Behance', link: 'https://www.reddit.net/' },
      { name: 'Snapchat', link: 'https://www.snapchat.com/' },
      { name: 'Twitch', link: 'https://www.twitch.com/' },
      { name: 'Github', link: 'https://www.github.com/' },
    ].map(i => icnShape(i)()),
    align: 'left',
    mediaQueries: [
      {
        global: true,
        selector: '.drzSocialMedia',
        properties: [],
      },
    ],
    newWindow: false,
    wrapClassList: [],
    localSize: null,
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/social-media/droplet.schema.js